import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Company } from "./_types"

const PATH = "/companies"

export type GetCompanies = Array<Company>

export const fetchGetCompanies = defineFetcher((): Promise<GetCompanies> => {
  return GET(PATH)
})
